import React from "react";
import styled from "styled-components";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import grey from "@material-ui/core/colors/grey";

export const NameCell = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
`;

export const Name = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Benchmark = styled.div`
  font-size: 11px;
  line-height: normal;
  color: ${grey[500]};
  margin-right: 22px;
`;

export const PassIcon = styled((props) => <CheckIcon {...props}/>)`
  font-size: 16px !important;
  position: absolute;
  top: ${(props) => (props.showBenchmark ? "9px" : "16px")};
  left: 12px;
  color: #1cc7a0;
`;

export const FailIcon = styled((props) => <ClearIcon {...props}/>)`
  font-size: 16px !important;
  position: absolute;
  top: ${(props) => (props.showBenchmark ? "9px" : "16px")};
  left: 12px;
  color: #dd1a8e;
`;

export const Filler = styled.div`
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/DataTableRow/style.js